import { render, staticRenderFns } from "./TheConsents.vue?vue&type=template&id=2be9a6cb"
import script from "./TheConsents.vue?vue&type=script&lang=js"
export * from "./TheConsents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports